@if (navService.user$ | async) {
  <aecom-header
    [productname]="productname"
    [productsubtitle]="productsubtitle"
    [productmaintitle]="productmaintitle"
    [user]="navService.user$ | async"
    [logoutAction]="authService.logout.bind(authService)"
    [theme]="'dark'"
    [noMenu]="true"
    [showAppMenu]="true"
    [appItems]="appItems"
  ></aecom-header>
}

<div
  class="image"
  [ngClass]="(navService.user$ | async) ? 'showHeader' : 'hideHeader'"
>
  <div class="main-body">
    <div>
      <div [ngClass]="icon" class="icon-row"></div>
    </div>

    <div class="title-row">{{ title }}</div>

    @for (content of contents; track content) {
      <div class="content-row">{{ content }}</div>
    }

    @if (showButtonAndContact) {
      <div class="button-row">
        <aecom-button
          innerClass="btn blue btn-icon solid mx-auto"
          (click)="refreshPage()"
        >
          {{ buttonText }}
        </aecom-button>
      </div>
    }
  </div>

  <div class="foot-row">
    <div class="foot-left-section">
      {{ copyRight }}
    </div>

    @if (showButtonAndContact) {
      <div class="foot-right-section">
        <div class="labelBox">Support</div>
        <div class="emailBox">
          <a href="mailto:support@bbjnyc.com">support@bbjnyc.com</a>
        </div>
      </div>
    }
  </div>
</div>
